import {
  useV2CreatePaymentCreditMutation,
  useV2UpdatePaymentCreditMutation,
  useV2DeletePaymentCreditMutation,
} from "@generated";
import type { V2PaymentCreditResource } from "@generated";
import type { PaymentCreditFormValues } from "../types";

// Build the JSON:API `data` body for create/update. The required `account`
// relationship is inferred from auth server-side, so we omit it and cast (same
// pattern as the Currencies MSPA).
export const buildPaymentCreditData = (
  values: PaymentCreditFormValues,
  id?: string
): V2PaymentCreditResource => {
  return {
    type: "payment-credits",
    ...(id ? { id: Number(id) } : {}),
    attributes: {
      "payment-source": values.paymentSource,
      description: values.description,
      criteria: values.criteria || "",
    },
  } as unknown as V2PaymentCreditResource;
};

export const usePaymentCreditMutations = () => {
  const [create, createState] = useV2CreatePaymentCreditMutation();
  const [update, updateState] = useV2UpdatePaymentCreditMutation();
  const [destroy, destroyState] = useV2DeletePaymentCreditMutation();

  return {
    create: (values: PaymentCreditFormValues) =>
      create({ body: { data: buildPaymentCreditData(values) } }).unwrap(),

    update: (id: string, values: PaymentCreditFormValues) =>
      update({
        id: Number(id),
        body: { data: buildPaymentCreditData(values, id) },
      }).unwrap(),

    // Payment credits are not soft-deleted; this is a permanent delete.
    destroy: (id: string) => destroy({ id: Number(id) }).unwrap(),

    states: { createState, updateState, destroyState },
  };
};

export default usePaymentCreditMutations;
